// client/src/contexts/NotificationContext.jsx

import React, { createContext, useState, useEffect } from 'react';
import notificationService from '../services/notificationService';
import NotificationContainer from '../components/ui/NotificationContainer';

// Créer le contexte
export const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);

  // S'abonner aux notifications
  useEffect(() => {
    const unsubscribe = notificationService.addListener(setNotifications);
    return unsubscribe;
  }, []);

  // Fonction pour supprimer une notification
  const removeNotification = (id) => {
    notificationService.removeNotification(id);
  };

  // Valeur du contexte
  const value = {
    notifications,
    addNotification: notificationService.addNotification.bind(notificationService),
    removeNotification,
    clearAll: notificationService.clearAllNotifications.bind(notificationService),
    success: notificationService.success.bind(notificationService),
    error: notificationService.error.bind(notificationService),
    warning: notificationService.warning.bind(notificationService),
    info: notificationService.info.bind(notificationService)
  };

  return (
    <NotificationContext.Provider value={value}>
      {children}
      <NotificationContainer 
        notifications={notifications} 
        removeNotification={removeNotification} 
      />
    </NotificationContext.Provider>
  );
};

export default NotificationProvider;